const ORDER_LIST = [
    'durationStart',
    'buyNowPrice',
    'quantity',
    'discount',
    'recommendedRetailPrice',
];
export const ORDER_OPTIONS = ORDER_LIST.map((order) => ({
    key: order,
    label: `resource.auction.properties.order_by.options.${order}`,
}));
